import React, { useEffect, useState } from 'react'
import { SessionManager } from "../services/SessionManager/SessionManager";
import { Navigate } from 'react-router-dom';
import { BuyerAPIHandler } from "../services/NetworkClient/BackendAPIs/BuyerAPIHandler";
import GGLoaderView from "../components/UtilityComponents/GGLoaderView/GGLoaderView";
import { ErrorLogger } from "../utils/Logger";


type SellerRouteProps = {
	components: Array<any>;
};

// Allow access to only seller users who are logged in
const SellerRoute: React.FC<SellerRouteProps> = ({components}) => {
  const [isLoading, setIsLoading] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isSeller, setIsSeller] = useState(false);

  useEffect(() => {
    const checkSession = async () => {
      const hasToken = SessionManager.shared.isLoggedin();
      
      if (!hasToken) {
        setIsAuthenticated(false);
        setIsLoading(false);
        return;
      }

      // Load buyer from API if not in memory (e.g., on page refresh)
      if (!SessionManager.shared.buyer) {
        try {
          const buyer = await BuyerAPIHandler.shared.getBuyerByAuthToken();
          SessionManager.shared.buyer = buyer;
        } catch (error) {
          ErrorLogger.log(error, 'SellerRoute.checkSession');
          setIsAuthenticated(false);
          setIsLoading(false);
          return;
        }
      }

      setIsAuthenticated(true);
      setIsSeller(SessionManager.shared.isSeller());
      setIsLoading(false);
    };

    checkSession();
  }, []);

  if (isLoading) {
    return <GGLoaderView />;
  }

  return isAuthenticated && isSeller ? 
  (<> {components.map((Component, index) => <Component key={index} />)} </>) 
  : 
  ( <Navigate to={"/login"}/>)
}

export default SellerRoute